import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { SolidButton } from './ButtonComponents';
import LoginPromptModal from '../authComponents/LoginPromptModal'; // Make sure this path is correct

export function RentNowButton({ book, className = "" }) {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const subscription = useSelector((state) => state.subscription.subscription);

  const [showLoginPrompt, setShowLoginPrompt] = useState(false); // 🔔 Modal state

  const handleClick = () => {
    if (!isAuthenticated) {
      setShowLoginPrompt(true); // 🔔 Show login modal
      return;
    }

    if (!subscription) {
      toast.error('You need an active subscription to rent books.');
      return;
    }

    if (subscription.status !== 'ACTIVE') {
      toast.error('Your subscription is not active.');
      return;
    }

    if (subscription.remainingDays !== undefined && subscription.remainingDays <= 0) {
      toast.error('Your subscription has expired.');
      return;
    }

    if (!subscription.selectedPlan || !subscription.selectedPackageDetails) {
      toast.error('Subscription details are incomplete.');
      return;
    }
// console.log("Book details: ", book);
    if(book.inStock == "OUT_OF_STOCK"){
      toast.error('This book is currently out of stock.');
      return;
    }

    navigate(`/order-confirmation/${book.id}`);
  };

  return (
    <>
      <SolidButton onClick={handleClick} className={`${className}`}>
        Rent Now
      </SolidButton>

      {/* 🔔 Login Modal */}
      {showLoginPrompt && (
        <LoginPromptModal
          isOpen={showLoginPrompt}
          onClose={() => setShowLoginPrompt(false)}
        />
      )}
    </>
  );
}

RentNowButton.propTypes = {
  book: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  className: PropTypes.string,
};

